<template>
    <div id="___gatsby"><div style="outline:0" tabindex="-1" id="gatsby-focus-wrapper"><div class="main-grid"><div id="content"><div></div></div><a href="#main" class="screen-reader-text" data-nosnippet="true">Skip to main content</a>

        <Header></Header>
        <div class="header-overlay"></div>
        <main role="main" class="main" id="main">
            <section class="background background--color0 black-text css-p5e12j" id="account-home">
                <div class="container container--account-home ">
                    <div class="hero hero--image">
                        <div class="hero__content">
                            <HomeMainText></HomeMainText>
                        </div>
                        <div class="hero__image">
                            <div style=""  class="outer-gatsby-image-wrapper outer-gatsby-image-wrapper-4ldZQgNQNkaW33Xj6S0cQG">
                                <div data-gatsby-image-wrapper=""
                                     class="gatsby-image-wrapper gatsby-image-wrapper-constrained gatsby-image-wrapper-4ldZQgNQNkaW33Xj6S0cQG ">
                                    <div style="max-width:713px;display:block"><img alt="" role="presentation"
                                                                                    aria-hidden="true"
                                                                                    src="data:image/svg+xml;charset=utf-8,%3Csvg height='650' width='713' xmlns='http://www.w3.org/2000/svg' version='1.1'%3E%3C/svg%3E"
                                                                                    style="max-width:100%;display:block;position:static">
                                    </div>
                                    <div aria-hidden="true" data-placeholder-image=""
                                         style="opacity:0;transition:opacity 500ms linear;object-fit:cover"></div>
                                    <picture>
                                        <source type="image/webp"
                                                srcset="/images/TradeMarkRev.gif">
                                        <source type="image/gif"
                                                srcset="/images/TradeMarkRev.gif">
                                        <img width="713" height="650" class="gatsby-image-4ldZQgNQNkaW33Xj6S0cQG"
                                             data-main-image="" style="object-fit:cover;opacity:1" decoding="async"
                                             loading="eager" alt="Hero Image"></picture>
                                    <noscript>
                                        <picture>
                                            <source type="image/webp"
                                                    srcSet="/images/TradeMarkRev.gif"/>
                                            <source type="image/gif"
                                                    srcSet="/images/TradeMarkRev.gif"/>
                                            <img width="713" height="650" class="gatsby-image-4ldZQgNQNkaW33Xj6S0cQG"
                                                 data-main-image="" style="object-fit:cover;opacity:1" decoding="async"
                                                 loading="eager" alt="Hero Image"/></picture>
                                    </noscript>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div class="section-home-serve">
                <div class="padding-global">
                    <div class="container-large">
                        <div class="home-serve-components">
                            <div class="max-width-medium">
                                <div class="heading-wrapper text-align-center header-before-form-type-blocks">
                                    <div data-w-id="34054c03-cde1-b0dc-561b-0d19474eadb3"
                                         style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); opacity: 1; transform-style: preserve-3d;"
                                         class="kicker">TRADEMARK OWNERS
                                    </div>
                                    <h2 data-w-id="ad3fbb86-17a5-4f56-4850-7a185a94d124"
                                        style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); opacity: 1; transform-style: preserve-3d;">
                                        We provide solutions for your trademark’s problems</h2>
                                </div>
                            </div>
                            <div data-w-id="a844fa4f-2cdd-3d20-e7b0-fe30018412c3"
                                 style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); opacity: 1; transform-style: preserve-3d;"
                                 class="home-serve-btm-wrapper">
                                <div class="home-serve-card item1"><img
                                    src="/icons/reshot-icon-business-law-E47WMN2SYH.svg"
                                    loading="lazy" alt="" class="image-11">

                                    <h4>Trademark Office Action</h4>
                                    <p>A Trademark Office Action is a formal letter or communication issued by...</p>
                                    <div class="padding-top padding-medium"><RouterLink to="trademark-office-action"
                                                                                        class="button-link-with-icon w-inline-block form-link-with-arrow">
                                        <div>EXPLORE The SOLUTION</div>
                                        <div class="icon-1x1-small_c w-embed">
                                            <svg aria-hidden="true" fill="currentColor" role="img" viewBox="0 0 20 21"
                                                 xmlns="http://www.w3.org/2000/svg"><title>Arrow Right</title>
                                                <polygon
                                                    points="16.172 9 10.101 2.929 11.515 1.515 20 10 19.293 10.707 11.515 18.485 10.101 17.071 16.172 11 0 11 0 9"></polygon>
                                            </svg>
                                        </div>
                                    </RouterLink></div>
                                </div>
                                <div class="home-serve-card item2"><img
                                    src="/icons/reshot-icon-business-plan-YGAZQ5JHBP.svg"
                                    loading="lazy" alt="" class="image-11"><h4>Statement Of Use</h4>
                                    <p>When a trademark application is filed with the USPTO, the applicant...</p>
                                    <div class="padding-top padding-medium"><RouterLink
                                        to="statement-of-use"
                                        class="button-link-with-icon w-inline-block form-link-with-arrow">
                                        <div>EXPLORE The SOLUTION</div>
                                        <div class="icon-1x1-small_c w-embed"
                                             style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;">
                                            <svg aria-hidden="true" fill="currentColor" role="img" viewBox="0 0 20 21"
                                                 xmlns="http://www.w3.org/2000/svg"><title>Arrow Right</title>
                                                <polygon
                                                    points="16.172 9 10.101 2.929 11.515 1.515 20 10 19.293 10.707 11.515 18.485 10.101 17.071 16.172 11 0 11 0 9"></polygon>
                                            </svg>
                                        </div>
                                    </RouterLink></div>
                                </div>
                                <div class="home-serve-card item3"><img
                                    src="/icons/reshot-icon-business-trip-L2YQNRCPFM.svg"
                                    loading="lazy" alt="" class="image-11"><h4>Statement Of Use Extension</h4>
                                    <p>The Statement of Use Extension, also known as the Requ...</p>
                                    <div class="padding-top padding-medium"><RouterLink
                                        to="statement-of-use-extension"
                                        class="button-link-with-icon w-inline-block form-link-with-arrow">
                                        <div>EXPLORE The SOLUTION</div>
                                        <div class="icon-1x1-small_c w-embed">
                                            <svg aria-hidden="true" fill="currentColor" role="img" viewBox="0 0 20 21"
                                                 xmlns="http://www.w3.org/2000/svg"><title>Arrow Right</title>
                                                <polygon
                                                    points="16.172 9 10.101 2.929 11.515 1.515 20 10 19.293 10.707 11.515 18.485 10.101 17.071 16.172 11 0 11 0 9"></polygon>
                                            </svg>
                                        </div>
                                    </RouterLink></div>
                                </div>
                                <div class="home-serve-card item4"><img
                                    src="/icons/reshot-icon-business-success-XVD94KNHC5.svg"
                                    loading="lazy" alt="" class="image-11"><h4>Trademark Renewal</h4>
                                    <p>To maintain the trademark's protection beyond the...</p>
                                    <div class="padding-top padding-medium"><RouterLink to="trademark-renewal"
                                                                               class="button-link-with-icon w-inline-block form-link-with-arrow">
                                        <div>EXPLORE The SOLUTION</div>
                                        <div class="icon-1x1-small_c w-embed">
                                            <svg aria-hidden="true" fill="currentColor" role="img" viewBox="0 0 20 21"
                                                 xmlns="http://www.w3.org/2000/svg"><title>Arrow Right</title>
                                                <polygon
                                                    points="16.172 9 10.101 2.929 11.515 1.515 20 10 19.293 10.707 11.515 18.485 10.101 17.071 16.172 11 0 11 0 9"></polygon>
                                            </svg>
                                        </div>
                                    </RouterLink></div>
                                </div>
                                <div class="home-serve-card  item5"><img
                                    src="/icons/reshot-icon-business-idea-VKY8DHZPWB.svg"
                                    loading="lazy" alt="" class="image-11"><h4>Trademark Revival</h4>
                                    <p>Trademark revival, also known as trademark restoration or revival of a lapsed...</p>
                                    <div class="padding-top padding-medium"><RouterLink to="trademark-revival"
                                                                               class="button-link-with-icon w-inline-block form-link-with-arrow">
                                        <div>EXPLORE The SOLUTION</div>
                                        <div class="icon-1x1-small_c w-embed">
                                            <svg aria-hidden="true" fill="currentColor" role="img" viewBox="0 0 20 21"
                                                 xmlns="http://www.w3.org/2000/svg"><title>Arrow Right</title>
                                                <polygon
                                                    points="16.172 9 10.101 2.929 11.515 1.515 20 10 19.293 10.707 11.515 18.485 10.101 17.071 16.172 11 0 11 0 9"></polygon>
                                            </svg>
                                        </div>
                                    </RouterLink></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section-home-about">
                <div class="padding-global">
                    <div class="container-large">
                        <div class="home-about-component v1">
                            <div class="heading-wrapper text-align-center">
                                <div class="kicker">ABOUT OUR LEGAL SERVICES</div>
                                <h2>Cohn Legal’s Dynamic, Comprehensive Technology Simplifies The Trademark Process</h2></div>
                            <div class="home-about-btm-wrap">
                                <div class="home-about-btm-card">
                                    <div class="home-about-btm-card-line"></div>
                                    <div class="text-size-xlarge custome">3 Business <span>Days</span></div>
                                    <div class="text-size-medium">Estimated time to file a new trademark application</div>
                                </div>
                                <div class="home-about-btm-card">
                                    <div class="home-about-btm-card-line"></div>
                                    <div class="text-size-xlarge custome"><span>24 Hours</span></div>
                                    <div class="text-size-medium">Estimated time  to speak with a Lawyer</div>
                                </div>
                            </div>
                            <p style="font-size: 24px"> </p>
                        </div>

                    </div>
                </div>
            </div>
        </main>
        <footer class="footer footer-home">
            <div class="footer__top">
                <p class="footer__headline" style="display: block">Trademark Registration</p>
                <div class="text-block footer__top-sub-heading">
                    <p>We deliver success - Our trademark lawyers are experts.
                    The legal industry has gotten a bad rep for obscene hourly rates and “spontaneous” billing. We will never do that to you. During your initial onboarding with the firm, we will learn about your needs and craft a fully customer-built, case scope and budget. We take a hands on approach with our clients and understand deeply each client’s particular situation before beginning any work.   Starting a business should be fun.  We want to make sure you don’t forget that..</p>
                </div>

                <div class="button-wrap">
                    <RouterLink
                        class="cta cta--regular cta--blue-3 Trademark-Registration Trademark-Registration_bottom"
                        to="trademark-registration-process"
                    >
                        <div>BEGIN TM REGISTRATION</div>
                        <div class="icon-1x1-small w-embed"
                             style="transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;">
                            <svg aria-hidden="true" fill="currentColor" role="img" viewBox="0 0 20 21"
                                 xmlns="http://www.w3.org/2000/svg"><title>Arrow Right</title>
                                <polygon
                                    points="16.172 9 10.101 2.929 11.515 1.515 20 10 19.293 10.707 11.515 18.485 10.101 17.071 16.172 11 0 11 0 9"></polygon>
                            </svg>
                        </div>
                    </RouterLink>
                </div>
            </div>
            <Footer></Footer>
        </footer>
    </div>
    </div>
        <div id="gatsby-announcer"
             style="position:absolute;top:0;width:1px;height:1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0"
             aria-live="assertive" aria-atomic="true">Navigated to Welcome back
        </div>
    </div>
    <div>
  </div>
</template>

<script>
import HomeMainText from '@/components/HomeMainText.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import {to_top} from "@/helper";

export default {
    components: {
        HomeMainText,
        Header,
        Footer
    },
    mounted() {
        to_top()
    }
}
</script>

<style lang="css" scoped src="@/styles/home.css"></style>
<style>
.hero.hero--image {
    justify-content: start;
}
.hero__content{
    max-width:none!important;
    width: 80% !important;
}
.hero__image {
    display: none!important;
}
.footer-home #bottom-bar {
    display: none;
}

.start-for-free-button svg{
    width: 0.85rem!important;
    height: 0.85rem!important;
    display: inline!important;
    margin-left: 0.75rem!important;
    vertical-align: middle;
}

.start-for-free-button {
    --tw-text-opacity: 1!important;
    color: rgb(255 255 255/var(--tw-text-opacity))!important;
    letter-spacing: -.025rem!important;
    line-height: 1.75rem!important;
    font-weight: 600!important;
    font-size: 1.425rem!important;
    padding-left: 1.75rem!important;
    padding-right: 1.75rem!important;
    padding-bottom: 14px!important;
    padding-top: 14px!important;
    --tw-bg-opacity: 1!important;
    background-color: #F45A26!important;
    --tw-border-opacity: 1!important;
    border-color: rgb(244 90 39/var(--tw-border-opacity))!important;
    border-radius: 9999px!important;
    white-space: nowrap!important;
    align-self: flex-start!important;
}
.text-block.footer__top-sub-heading {
    display: inline-block;
}
.button-wrap {
    text-align: center;
    display: inline-block;
    width: calc(100% - 940px);
    vertical-align: top!important;
}
.button-wrap {

}
.Trademark-Registration:hover .icon-1x1-small{
    transform: translate3d(10px, 0px, 0px)!important;

}

.Trademark-Registration {
    height: 64px!important;
    border-radius: 100px!important;
    justify-content: center!important;
    align-items: center!important;
    transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
    transform-style: preserve-3d;
    grid-column-gap: 0.5rem;
    grid-row-gap: 0.5rem;
    color: var(--white);
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-left: 80px!important;
    padding-right: 80px!important;
    text-decoration: none;
    display: flex;
    transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
    transform-style: preserve-3d;
    opacity: 1;
    background-color: rgb(50, 130, 248);
}
.Trademark-Registration_bottom {
    background-color: #F45A26!important;
}
.Trademark-Registration_bottom:hover {
    background-color: #b83509!important;
}
.Trademark-Registration .icon-1x1-small {
    width: 1rem;
    height: 1rem;
    flex: none;
    transition: 0.6s;
}
.Trademark-Registration svg:not(:root) {
    overflow: hidden;
    vertical-align: top;
}
@media screen and (max-width:768px){
    .button-wrap {
        display: block;
        width: 100%;
    }
    .button-wrap a {
        margin-bottom: 40px;
    }
    .hero__content{
        width: 100% !important;
    }
}
.header-before-form-type-blocks div{
    font-size: 19px!important;
}
.header-before-form-type-blocks h2{
    font-size: 40px!important;
}
</style>
